module.exports = __webpack_public_path__ + "img/xian.a0a88bb4.png";